export const BASE_URL = "https://akhil-systems-test.squbix.com/";
// export const BASE_URL = "http://localhost:5002/";
